import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';

export interface CollectionFieldProps {
  control: Control<any>;
  collections?: any[];
  loading?: boolean;
  name: string;
}

const CollectionField = ({ control, collections, loading, name }: CollectionFieldProps) => {
  const { field } = useController({ control, name });

  useEffect(() => {
    if (collections && field.value) {
      field.onChange(null);
    }
  }, [collections]);

  const getOptionLabel = optionId => collections?.find(e => e.id === optionId)?.title ?? '';

  return (
    <Autocomplete
      data-cy="select-collection"
      clearOnBlur
      disableClearable
      disabled={!collections}
      getOptionLabel={getOptionLabel}
      handleHomeEndKeys
      renderOption={(props, optionId) => (
        <li {...props} key={optionId} data-cy={`select-option-${getOptionLabel(optionId)}`}>
          {getOptionLabel(optionId)}
        </li>
      )}
      options={(collections ?? []).map(e => e.id)}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          label="Collections"
        />
      )}
      {...field}
      onChange={(event, option) => field.onChange(option)}
    />
  );
};

export default CollectionField;
